import type {
  SchoolStudent,
  SchoolStudentCreateRequest,
  SchoolStudentUpdateRequest,
} from '../types';

const studentUpdateFields: Array<keyof SchoolStudentUpdateRequest> = [
  'name',
  'email',
  'phone',
  'code',
  'studentId',
  'dateOfBirth',
  'gender',
  'address',
  'parentName',
  'parentPhone',
  'parentEmail',
  'emergencyContact',
  'emergencyPhone',
  'grade',
  'schoolYear',
  'enrollmentDate',
  'academicLevel',
  'subjects',
  'classId',
];

const toComparableValue = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return JSON.stringify(value);
  }

  return value ?? '';
};

export const buildStudentUpdatePayload = (
  student: SchoolStudent,
  formData: SchoolStudentCreateRequest
): SchoolStudentUpdateRequest => {
  const originalValues = student as unknown as Record<string, unknown>;
  const submittedValues = formData as unknown as Record<string, unknown>;
  const updateData: Record<string, unknown> = {};

  studentUpdateFields.forEach((field) => {
    const originalValue = toComparableValue(originalValues[field]);
    const submittedValue = toComparableValue(submittedValues[field]);

    if (originalValue !== submittedValue) {
      updateData[field] = submittedValues[field];
    }
  });

  return updateData as SchoolStudentUpdateRequest;
};
